﻿import ShowcaseOrderApi from "../ShowcaseOrderApi";
import * as types from './ShowcaseOrderActionTypes'

function getShowcaseOrderSuccess(orders: any) {
    return { type: types.GET_SHOWCASE_ORDER_SUCCESS, result: orders };
}

export function getShowcaseOrder(orderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ShowcaseOrderApi.getShowcaseOrder(orderId).then((result: any) => {
            dispatch(getShowcaseOrderSuccess(result));
        });
}